module.exports = __webpack_public_path__ + "static/media/propic-9.2919c4e7.png";